export default {
    namespaced: true,
    state: {
        list: null,
        item: null,
        items: null
    },
    getters: {
        list: state => state.list,
        item: state => state.item,
        items: state => state.items
    },
    mutations: {
        SET_LIST(state, items) {
            state.list = items
        },
        SET_ITEM(state, item) {
            state.item = item
        },
        SET_ITEMS(state, items) {
            state.items = items
        }
    },
    actions: {
        async getList({ commit }, brandId) {
            const resp = await this.$axios.get(
                `/public/brand-page/${brandId}/categories`
            )

            commit('SET_LIST', resp.data.display_categories)
        },
        async getItem({ commit }, payload) {
            const resp = await this.$axios.get(
                `/public/brand-page/${payload.brandId}/categories/${payload.slug}`
            )

            commit('SET_ITEM', resp.data.display_category)
        },
        async getItems({ commit }, payload) {
            const resp = await this.$axios.get(
                `/public/brand-page/${payload.brandId}/categories/${payload.slug}/items`,
                {
                    params: {
                        ...payload.filters
                    }
                }
            )

            commit('SET_ITEMS', resp.data)
        }
    }
}
